import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { HomePageRoutingModule } from './home-routing.module';

import { HomePage } from './home.page';

// Pipes
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';

// Components
import { ProductCardComponent } from '../../components/product-card/product-card.component';
import { VideoSectionComponent } from '../../components/video-section/video-section.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { PreFooterComponent } from '../../components/pre-footer/pre-footer.component';
import { CalendarComponent } from './../../components/calendar/calendar.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, HomePageRoutingModule],
  declarations: [HomePage, ProductCardComponent, VideoSectionComponent, FooterComponent, PreFooterComponent, CalendarComponent, SafeHtmlPipe],
  exports: [SafeHtmlPipe],
})
export class HomePageModule {}
